import React from 'react';
import SvgLogo from './logo.svg';
export type LogoProps = {
  className?: string;
};

export default function Logo({ className }: LogoProps) {
  return <img src={SvgLogo} alt="Logo" />;
}
